export default "__VITE_ASSET__BJSXba91__"